import produce from "immer";

import { ModelState } from "../../../interfaces/modelState";

interface OtherMutationModel {
  description: string;
  startDate?: string;
}

interface State {
  data: Partial<OtherMutationModel>;
  loading: boolean;
  modelState: ModelState | null;
}

export const initialState: State = {
  data: {
    description: undefined,
  },
  loading: false,
  modelState: null,
};

type Action =
  | { type: "UPDATE_OTHER_MUTATION_DATA"; payload: Partial<OtherMutationModel> }
  | { type: "UPDATE_OTHER_MUTATION_ERROR"; payload: ModelState }
  | { type: "UPDATE_OTHER_MUTATION_FETCH_START" }
  | { type: "UPDATE_OTHER_MUTATION_FETCH_ERROR"; payload: ModelState };

export const otherMutationReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "UPDATE_OTHER_MUTATION_DATA":
      return produce(state, (draft) => {
        draft.data = { ...draft.data, ...action.payload };
      });
    case "UPDATE_OTHER_MUTATION_ERROR":
      return produce(state, (draft) => {
        draft.modelState = action.payload;
      });
    case "UPDATE_OTHER_MUTATION_FETCH_START":
      return produce(state, (draft) => {
        draft.loading = true;
      });
    case "UPDATE_OTHER_MUTATION_FETCH_ERROR":
      return produce(state, (draft) => {
        draft.loading = false;
        draft.modelState = action.payload;
      });
  }
};
